<mat-sidenav-container (backdropClick)="closeSlideBar()">
  <mat-sidenav position="end" [opened]="sideBarOpened" disableClose>
    <router-outlet name="sidebar"></router-outlet>
  </mat-sidenav>
  <mat-sidenav-content id="main">
    <div class="clamp">
      <table mat-table [dataSource]="lignesContrat" class="mt-2.5">
        <ng-container matColumnDef="designation">
          <th mat-header-cell *matHeaderCellDef> Article </th>
          <td mat-cell *matCellDef="let ligne"> {{ligne.article.designation}} </td>
        </ng-container>
        <ng-container matColumnDef="code_article">
          <th mat-header-cell *matHeaderCellDef> Code article </th>
          <td mat-cell *matCellDef="let ligne"> {{ligne.article.code_article}} </td>
        </ng-container>

        <ng-container matColumnDef="qte_stock">
          <th mat-header-cell *matHeaderCellDef> Stock </th>
          <td mat-cell *matCellDef="let ligne">
            {{ ligne.qte_stock }}
          </td>
        </ng-container>
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef> </th>
          <td mat-cell *matCellDef="let ligne">
            <button type="button" mat-raised-button (click)="editStock(ligne.article)" class="button-white">Modifier le
              stock</button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns">
        </tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
    <article class="no-content" *ngIf="lignesContrat.data.length == 0 && !load">
      <p>Aucun résultat</p>
    </article>
  </mat-sidenav-content>
</mat-sidenav-container>